import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./PoliciesSidebar.scss";

const PoliciesSidebar = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [open, setOpen] = useState(false);

  // Detect screen size
  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  // Close menu after a link click (mobile only)
  const handleLinkClick = () => {
    if (isMobile) setOpen(false);
  };

  return (
    <>
      {/* Mobile hamburger button */}
      {isMobile && (
        <button className="mobile-menu-btn" onClick={() => setOpen(!open)}>
          ☰
        </button>
      )}

      <div className={`policies-sidebar ${open ? "open" : ""} ${isMobile ? "mobile" : ""}`}>
        <h3>Policies</h3>

        <nav className="sidebar-links">
          <NavLink to="/policies/terms" className="link" onClick={handleLinkClick}>
            Terms & Conditions
          </NavLink>

          <NavLink to="/policies/privacy" className="link" onClick={handleLinkClick}>
            Privacy Notice & Consent
          </NavLink>

          <NavLink to="/policies/gdpr" className="link" onClick={handleLinkClick}>
            GDPR Policy
          </NavLink>

          <NavLink to="/policies/refund" className="link" onClick={handleLinkClick}>
            Refund / Cancellation Policy
          </NavLink>

          <NavLink to="/policies/house-rules" className="link" onClick={handleLinkClick}>
            House Rules
          </NavLink>
        </nav>
      </div>
    </>
  );
};

export default PoliciesSidebar;
